import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { selectTranslations, textKeyLookup } from './ducks';

const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';

function translate(Component, textKeys, options = { wait: true }) {
	class TranslationProvider extends PureComponent {
		// eslint-disable-next-line react/state-in-constructor
		state = {
			hydrated: false
		};

		componentDidMount() {
			this.hydrate(this.props.translations, unavailableTextKeys =>
				this.props.dispatch(textKeyLookup(unavailableTextKeys))
			);
		}

		componentDidUpdate() {
			const { translations } = this.props;
			this.hydrate(translations);
		}

		// componentWillReceiveProps({ translations }) {
		// 	this.hydrate(translations);
		// }

		hydrate = (translations, cb) => {
			if (this.state.hydrated) return;
			const unavailableTextKeys = textKeys.filter(textKey => typeof translations[textKey] === 'undefined');
			if (unavailableTextKeys.length === 0) {
				const translated = textKeys.reduce(
					(prev, curr) => ({
						...prev,
						[curr]: translations[curr] || ''
					}),
					{}
				);
				this.setState({ hydrated: true, translated });
			} else if (cb) {
				cb(unavailableTextKeys);
			}
		};

		render() {
			const { translations, ...rest } = this.props;
			return (
				this.state.hydrated && (
					// eslint-disable-next-line react/jsx-props-no-spreading
					<Component {...rest} translations={this.state.translated} />
				)
			);
		}
	}

	const mapStateToProps = state => ({
		translations: selectTranslations(state)
	});
	TranslationProvider.displayName = `TranslationProvider(${getDisplayName(Component)})`;
	// TODO extract following out of TranslationProvider
	const { formikEnhancer } = options;
	if (formikEnhancer) {
		return connect(mapStateToProps)(formikEnhancer(TranslationProvider));
	}
	return connect(mapStateToProps)(TranslationProvider);
}

export default translate;
